import React from 'react'
import {UserContextProvider} from '../../../context/User'
import {SettingsContextProvider} from '../../../context/Settings/Settings'
import CalendarContainer from './CalendarContainer'

const CalendarMain = () => {
  return (
    <UserContextProvider>
      <SettingsContextProvider>
        <CalendarContainer />
      </SettingsContextProvider>
    </UserContextProvider>
  )
}
export default CalendarMain
